import { jwtDecode } from "jwt-decode";

export type JwtPayload = {
  sub?: string;
  source?: string;
  role?: string;
  //merchantId?: string;
  [key: string]: unknown; // extra fields
};

export function decodeJwt(token: string): JwtPayload | null {
  try {
    return jwtDecode<JwtPayload>(token);
  } catch (e) {
    console.error("Failed to decode JWT:", e);
    return null;
  }
}
